import React from "react"
import LxHeader from "@/components/LxHeader"
import LxSwiper from "@/components/LxSwiper"
import styles from "./index.module.scss"
import media from "./media.module.scss"
import SectionTitle from './cmp/SectionTitle'
import MechanisList from './cmp/MechanisList'
import VideoSwiper from './cmp/VideoSlide'
import defaultSetting from '@/setting'
import { isMobile } from '@/utils/util'
import { swiperList, mechanisList } from "@/constants"
import LxFooter from '@/components/LxFooter'
const pic_01 = require("@/assets/images/home/video_cover1.png")
const pic_02 = require("@/assets/images/home/video_cover2.png")
const video1 = 'https://www.sinochem.com/Portals/121/video/2023/20230823video.mp4'
const video2 = 'https://www.sinochem.com/Portals/121/video/2024xzxcp.mp4'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mechanisList,
      currentInfo: mechanisList[0],
      metaSwiperList: [
        {
          id: 1,
          url: pic_01,
          videoSrc: video1,
          isCurrent: true,
          isPrev: false,
          isNext: false,
          isPlay: false
        },
        {
          id: 2,
          url: pic_02,
          videoSrc: video2,
          isCurrent: false,
          isPrev: false,
          isNext: true,
          isPlay: false
        }
      ], // 视频源
      swipers: [], // 当前轮播视频组
      // 为了适配两个视频start
      swiperThird: {
        id: 3,
        url: '',
        videoSrc: '',
        isCurrent: false,
        isPrev: true,
        isNext: false,
        isPlay: false
      }, // 两个视频时补全第三个用
      paginationList: [],
      nextFlag: true,
      prevFlag: true
      // 为了适配两个视频end
    }
  }

  componentDidMount() {
    if(isMobile) window.location.href = `${defaultSetting.domain}/campus`
    let list = this.state.metaSwiperList
    if(list.length === 2) {
      let obj = this.state.swiperThird
      let copy = list.find(item => !item.isCurrent)
      obj.url = copy.url
      obj.videoSrc = copy.videoSrc
      this.setState({
        swipers: [...list, obj],
        paginationList: list
      })
    }
  }

  getMechanis = (index) => {
    mechanisList.forEach((item, idx) => {
      item.isActive = false
      if (index === idx) {
        item.isActive = true
      }
    })
    this.setState({
      currentInfo: mechanisList.find((item, idx) => idx === index),
      mechanisList,
    })
  }

  // 视频展示点击下一张
  doNext = () => {
    let list = this.state.swipers
    const len = list.length
    const prevIndex = list.findIndex(item => item.isCurrent)
    const current = prevIndex + 1 === len ? 0 : prevIndex + 1
    const nextIndex = current + 1 === len ? 0 : current + 1
    this.setSwiperList(list, current, prevIndex, nextIndex, 0)
    this.doPause(prevIndex)
  }

  // 视频展示点击上一张
  doPrev = () => {
    let list = this.state.swipers
    const len = list.length
    const nextIndex = list.findIndex(item => item.isCurrent)
    const current = nextIndex - 1 === -1 ? len - 1 : nextIndex - 1
    const prevIndex = current - 1 === -1 ? len - 1 : current - 1
    this.setSwiperList(list, current, prevIndex, nextIndex, 1)
    this.doPause(nextIndex)
  }

  // 点击分页器切换
  doDot = (current) => {
    let list = this.state.swipers
    const len = list.length
    const prevIndex = current - 1 === -1 ? len - 1 : current - 1
    const nextIndex = current + 1 === len ? 0 : current + 1
    this.setSwiperList(list, current, prevIndex, nextIndex, 2)
  }
  // 设置视频轮播
  setSwiperList = (list, current, prevIndex, nextIndex, handleType = 0) => {
    list.forEach((item, index) => {
      item.isCurrent = false
      item.isPrev = false
      item.isNext = false
      if ( index === current ) {
        item.isCurrent = true
      } else if ( index === prevIndex ) {
        item.isPrev = true
        item.videoSrc =  `${item.videoSrc}?v=${new Date().getTime()}`
        // 为了适配两个视频start
        if (handleType === 1) {
          item.url = list[nextIndex].url
          item.videoSrc = list[nextIndex].videoSrc
        }
        // 为了适配两个视频end
      } else if ( index === nextIndex ) {
        item.isNext = true
        item.videoSrc =  `${item.videoSrc}?v=${new Date().getTime()}`
        // 为了适配两个视频start
        if (handleType === 0) {
          item.url = list[prevIndex].url
          item.videoSrc = list[prevIndex].videoSrc
        }
        // 为了适配两个视频end
      }
    })
    // 为了适配两个视频-分页器start
    let arr = []
    if (handleType === 2) {
      const copy = list.find((item, index) => index !== current && item.videoSrc !== list[current].videoSrc)
      list.forEach((item, index) => {
        if(index !== current) {
          item.url = copy.url
          item.videoSrc = copy.videoSrc
        }
      })
      const currentIndex = this.state.paginationList.findIndex(item => item.isCurrent)
      arr = currentIndex === 1 ? [list.find(item => item.isPrev), list.find(item => item.isCurrent)] : [list.find(item => item.isCurrent), list.find(item => item.isNext)]
    } else if (handleType === 0) {
      const nextFlag = this.state.nextFlag
      arr = nextFlag ? [list.find(item => item.isPrev), list.find(item => item.isCurrent)] : [list.find(item => item.isCurrent), list.find(item => item.isPrev)]
      this.setState({
        nextFlag: !nextFlag
      })
    } else if (handleType === 1) {
      const prevFlag = this.state.prevFlag
      arr = prevFlag ? [list.find(item => item.isNext), list.find(item => item.isCurrent)] : [list.find(item => item.isCurrent), list.find(item => item.isNext)]
      this.setState({
        prevFlag: !prevFlag
      })
    }
    // 为了适配两个视频-分页器end
    this.setState({
      swipers: list,
      paginationList: arr //为了适配两个视频
    })
  }

  doPlay = (index) => {
    let list = this.state.swipers
    let node = document.getElementById(`video${index}`)
    node.play()
    list.forEach((item, idx) => {
      item.isPlay = false
      if(idx === index) {
        item.isPlay = !item.isPlay
      }
    })
    this.setState({
      swipers: list,
    })
  }
  doPause = (index) => {
    let list = this.state.swipers
    let node = document.getElementById(`video${index}`)
    node.pause()
    list.forEach((item) => {
      item.isPlay = false
    })
    this.setState({
      swipers: list,
    })
  }

  render() {
    return (
      <>
        <main className={`${styles.home} ${media.home}`}>
          <LxHeader></LxHeader>
          <LxSwiper list={swiperList}></LxSwiper>

          {/* 招聘机构 */}
          <section className="mechanis-section lx-bg-color-white">
            <div className="mechanis-bg">
              <div className='lx-container'>
                <SectionTitle title="招聘机构"></SectionTitle>
                <MechanisList list={this.state.mechanisList} current={this.getMechanis}></MechanisList>
                <div className="mechanis-content lx-flex">
                  <div className="lx-flex-shrink-0 content-left lx-fz0 lx-flex-row-center lx-hidden">
                    <img className="content-cover " style={{width: '100%', objectFit: 'contain', borderRadius: "4px"}} src={ this.state.currentInfo.img_url } alt=""></img>
                  </div>
                  <div className="lx-flex-grow-1 content-right lx-flex-column">
                    <div className="lx-flex-shrink-0 title lx-fz26 lx-fwBold lx-mb10">{ this.state.currentInfo.contentTitle }</div>
                    <div className="lx-flex-grow-1 content lx-fz16 lx-text-color-secondary" dangerouslySetInnerHTML={{__html: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + this.state.currentInfo.content }}></div>
                    <a href={this.state.currentInfo.toUrl} className="lx-flex-shrink-0 content-btn lx-flex-row-center lx-text-color-white lx-fz16" rel="noreferrer">查看职位</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
    
          {/* 视频演示 */}
          <section className="video-section">
            <div className='lx-container'>
              <SectionTitle title="视频展示"></SectionTitle>
              <div className="lx-flex-row-center">
                <VideoSwiper list={ this.state.swipers } paginationList={ this.state.paginationList } dot={this.doDot} play={this.doPlay} pause={this.doPause} prev={this.doPrev} next={this.doNext}></VideoSwiper>
              </div>
            </div>
          </section>
       
        </main>
        <LxFooter></LxFooter>
      </>
    )
  }
}

export default Home
